export default {
      id: "calendar-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#calendar-usage",
      toString: function () {
        return this.url;
      }
    }